// eslint-disable-next-line import/no-unresolved
import { toast } from 'react-toastify';

export function toastPendingPromise(state, action, message) {
  state.toast[action.meta.requestId] = toast.loading(message);
}

export function toastFulfilledPromise(
  state,
  action,
  { render, type = 'success', isLoading = false, autoClose = 2500 }
) {
  toast.update(state.toast[action.meta.requestId], {
    render,
    type,
    isLoading,
    autoClose,
  });
}

export const defaultRejectOptions = {
  render: 'Error occurred.',
  type: 'error',
  isLoading: false,
  autoClose: 2500,
};

export function toastRejectedPromise(
  state,
  action,
  options = defaultRejectOptions
) {
  toast.update(state.toast[action.meta.requestId], options);
}
